const partyIdCookieName = "votify";

export const getPartyIdFromStorage = (cookieName) => {
  if (!cookieName) cookieName = partyIdCookieName;
  const nameEQ = cookieName + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const setPartyIdToStorage = (partyId) => {
  const date = new Date();
  date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();
  document.cookie =
    partyIdCookieName + "=" + (partyId || "") + expires + "; path=/";
};
